// Calendar days as `YYYY-MM-DD` strings in the viewer's time zone: comparable
// with `<`, and with the `date` of release entries and campaign windows.

export const toLocalDay = (date: Date): string => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}`;
};

export const addDays = (day: string, days: number): string => {
  const [year, month, date] = day.split('-').map(Number);
  return toLocalDay(new Date(year, month - 1, date + days));
};

export const DAY_MS = 24 * 60 * 60 * 1000;
